import {useRef} from "react";
import {useFormContext} from "react-hook-form";
import {Button, message, Space} from "antd";
import {DeleteOutlined, FileOutlined, PlusCircleFilled} from "@ant-design/icons";
import {
  StyledContentListItem,
  StyledContentListUploadWrapper,
} from "../../../../../../../products/product-form/content-upload/content-upload.style";
import {FormFieldError} from "../../../../../../../../design-system/form-field";

export const MAX_FILE_SIZE = 5 * 1024 * 1024; // 5MB
export const FILE_LIMIT = 5;

export const ALLOWED_EXTENSIONS = [
  ".pdf",
  ".doc",
  ".docx",
  ".ppt",
  ".pptx",
  ".jpeg",
  ".jpg",
  ".png",
  ".svg",
  ".webp",
  ".zip",
  ".csv",
  ".mp4",
];

export const hasAllowedExtension = (file: File) => {
  const name = file.name.toLowerCase();
  return ALLOWED_EXTENSIONS.some((ext) => name.endsWith(ext));
};

export function CustomerServiceOrderDeliverWorkFormEvidenceOfDeliveryUpload() {
  const {
    watch,
    setValue,
    formState: {errors},
    clearErrors,
  } = useFormContext<{evidenceOfDelivery: File[]}>();
  const files = watch("evidenceOfDelivery") || [];
  const canAddMore = files.length < FILE_LIMIT;

  const fileInputRef = useRef<HTMLInputElement | null>(null);

  const handleButtonClick = () => {
    console.log("Clicked well");
    if (!canAddMore) return;
    console.log("Clicked not so well");
    fileInputRef.current?.click();
  };

  const handleAddFiles = (e: React.ChangeEvent<HTMLInputElement>) => {
    const selected = Array.from(e.target.files || []);
    if (!selected.length) return;

    const remainingSlots = FILE_LIMIT - files.length;
    if (remainingSlots <= 0) {
      message.error(`You can only upload ${FILE_LIMIT} files`);
      e.target.value = "";
      return;
    }

    // Filter based on size + type
    const validFiles: File[] = [];
    const rejected: File[] = [];

    for (const file of selected) {
      const isValidSize = file.size <= MAX_FILE_SIZE;
      const isValidType = hasAllowedExtension(file);

      if (isValidSize && isValidType) {
        validFiles.push(file);
      } else {
        rejected.push(file);
      }
    }

    // Limit to remaining slots
    const filesToAdd = validFiles.slice(0, remainingSlots);

    if (filesToAdd.length) {
      setValue("evidenceOfDelivery", [...files, ...filesToAdd], {
        shouldDirty: true,
        shouldValidate: true,
      });
      clearErrors("evidenceOfDelivery");
    }

    if (rejected.length) {
      message.error("Some files were rejected (invalid type or larger than 5MB).");
    }

    // allow selecting same file again later
    e.target.value = "";

    console.log({rejected});
  };

  const removeFile = (index: number) => {
    const next = files.filter((_, i) => i !== index);
    setValue("evidenceOfDelivery", next, {
      shouldDirty: true,
      shouldValidate: true,
    });
  };
  return (
    <div>
      <Space size={8} direction="vertical">
        <p>Upload a file to support your case</p>
        <StyledContentListUploadWrapper>
          <Space size={16} direction="vertical">
            <div>
              <p className="content-list-title">
                You can add multiple files like .pdf, .doc/.docx, .ppt/.pptx, .jpeg, .png,
                .svg, .webp, .zip, .csv, mp4
              </p>
              <Space direction="vertical" size={12} style={{display: "flex"}}>
                {files.slice(0, FILE_LIMIT).map((item, index) => (
                  <StyledContentListItem key={item.name}>
                    <div className="content-list-item-info">
                      <div className="content-list-item-name-wrapper">
                        <FileOutlined className="content-list-item-file-icon" />{" "}
                        <p className="content-list-item-name">
                          {`${item.name}. ${`(${Math.round(
                            item.size / 1024
                          ).toLocaleString()} KB)`}`}
                        </p>
                      </div>
                      <div>
                        <Space size={16}>
                          <Button
                            size="small"
                            type="text"
                            onClick={() => removeFile(index)}
                          >
                            <DeleteOutlined />
                          </Button>
                        </Space>
                      </div>
                    </div>
                  </StyledContentListItem>
                ))}
              </Space>
            </div>
            {/* {files.length < FILE_LIMIT && ( */}
            <>
              <input
                id="file-input"
                type="file"
                multiple
                hidden
                disabled={!canAddMore}
                onChange={handleAddFiles}
                ref={fileInputRef}
                accept=".pdf,.doc,.docx,.ppt,.pptx,.jpeg,.jpg,.png,.svg,.webp,.zip,.csv,.mp4"
              />
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                <Button
                  onClick={handleButtonClick}
                  size="small"
                  icon={<PlusCircleFilled />}
                  disabled={!canAddMore}
                >
                  {canAddMore ? "Upload file" : "Max 5 files"}
                </Button>
              </div>
            </>
            {/* )} */}
          </Space>
        </StyledContentListUploadWrapper>
        <FormFieldError errorMessage={errors.evidenceOfDelivery?.message} />
      </Space>
      {/* <input
        id="file-input"
        type="file"
        multiple
        hidden
        disabled={!canAddMore}
        onChange={handleAddFiles}
        ref={fileInputRef}
      />

      <label htmlFor="file-input">
        <button onClick={handleButtonClick} type="button" disabled={!canAddMore}>
          {canAddMore ? "Upload file" : "Max 5 files"}
        </button>
      </label> */}

      {/* <ul style={{marginTop: 12}}>
        {files.map((file, i) => (
          <li key={i}>
            {file.name} ({Math.round(file.size / 1024)} KB)
            <button type="button" onClick={() => removeFile(i)} style={{marginLeft: 8}}>
              Remove
            </button>
          </li>
        ))}
      </ul>

      {errors.evidenceOfDelivery && (
        <p style={{color: "red"}}>{errors.evidenceOfDelivery.message}</p>
      )} */}
    </div>
  );
}
